import React, { useState } from 'react';
import { List, ListItem, Tooltip, Grow, Typography } from '@material-ui/core';
import { socialmedia } from './social.json';
import { useStyles } from './useStyles';

export const SocialMedia = (props) => {
	
	const classes = useStyles();

	return (
		<List className={classes.listContainer}>
			<Grow in={true} timeout={1000} key={`grow-language`}>
				<ListItem
					rel="noopener noreferrer"
					component="select"
					className={classes.selectLanguage}
					onChange={props.onChange}
					value={props.language}
				>
					<option value="english">🇺🇸 ENGLISH</option>
					<option value="spanish">🇪🇸 ESPAÑOL</option>
				</ListItem>
			</Grow>
			{socialmedia.map((key) => {
				return (
					<Grow in={true} timeout={1000} key={`grow-${key.value}`}>
						<div className={classes.socialMediaList}>
						<Tooltip
							title={
								<Typography variant="body2" className={classes.tooltip}>
									{key.name}
								</Typography>
							}
							arrow
						>
							<ListItem
								component="a"
								href={key.page}
								key={key.value}
								target="_blank"
								rel="noopener noreferrer"
							>
								<img
									src={process.env.PUBLIC_URL + key.icon}
									alt={'Icono que redirige a ' + key.value}
									className={classes.icon}
								/>
							</ListItem>
						</Tooltip>
						</div>
					</Grow>
				);
			})}
		</List>
	);
};
